import format from 'date-fns/format';
import { translateDateFormat } from '../../shared/LanguageService';

export function parseNewsDate(text: string | null | undefined): Date | null {
    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(text || '');
    return match ? new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3])) : null;
}

export function toNewsDateText(date: Date | null): string | null {
    return date && !isNaN(date.getTime()) ? format(date, 'yyyy-MM-dd') : null;
}

export function formatNewsDateInReadersLanguage(text: string): string {
    const newsDate = parseNewsDate(text);
    return newsDate ? translateDateFormat(newsDate, 'PP') : '';
}

export function todayNewsDateText(): string {
    return format(new Date(), 'yyyy-MM-dd');
}
